var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { WINDOW_KEY } from "../../constants";
import { createModel } from "@byted/hooks";
import { RecordingMode } from "@bytereplay/core";
import { StandardRecorder } from "@bytereplay/recorder";
import { useEffect, useMemo, useState } from "react";
import useGeneralConfigs from "../useGeneralConfigs";
import CensoredDataMask from "./mask";
import { genAuthToken } from "./service";
const useSessionReplayCore = (initialState) => {
  const region = initialState == null ? void 0 : initialState.region;
  const [recordingId, setRecordingId] = useState("");
  const [isRecording, setIsRecording] = useState(false);
  const isTTP = (region == null ? void 0 : region.toLocaleUpperCase()) === "US";
  const censorshipMask = new CensoredDataMask();
  const recorder = new StandardRecorder({
    trackers: ["HTML", "Mouse", "Console", "Error", "Network", "Insight"],
    network: {
      captureResponseBody: false,
      captureRequestBody: true
    },
    environment: { type: isTTP ? "PROD-PUBLIC-US-TTP" : "PROD-PUBLIC-VA-TT" },
    html: {
      dataMasks: [censorshipMask]
    }
  });
  const blackBoxRecorder = new StandardRecorder({
    trackers: ["HTML", "Mouse", "Console", "Error", "Network", "Insight", "Performance"],
    network: {
      captureResponseBody: false,
      captureRequestBody: true
    },
    environment: { type: isTTP ? "PROD-PUBLIC-US-TTP" : "PROD-PUBLIC-VA-TT" },
    html: {
      dataMasks: [censorshipMask]
    },
    // 默认2分钟
    blackbox: {
      bufferTime: 3e5
    }
  });
  window[WINDOW_KEY.BLACKBOX_RECORDER_INSTANCE] = blackBoxRecorder;
  const { uid } = useGeneralConfigs();
  const startBlackboxRecording = () => __async(void 0, null, function* () {
    try {
      const { recordingId: recordingId2, token } = (yield genAuthToken(uid, region != null ? region : "")).data;
      const recordingContext = yield blackBoxRecorder.startRecording({
        id: recordingId2.toString(),
        token,
        mode: RecordingMode.Blackbox
      });
      window[WINDOW_KEY.BLACKBOX_RECORDER] = recordingContext;
      return recordingId2.toString();
    } catch (e) {
      return void 0;
    }
  });
  const dumpBlackboxRecording = () => __async(void 0, null, function* () {
    try {
      if (window[WINDOW_KEY.BLACKBOX_RECORDER]) {
        const { recordingId: _recordingId, token } = (yield genAuthToken(uid, region != null ? region : "")).data;
        window[WINDOW_KEY.BLACKBOX_RECORDER]._dumpConfig = { id: _recordingId.toString(), token };
        const recordingContext = window[WINDOW_KEY.BLACKBOX_RECORDER];
        const recordingId2 = yield recordingContext == null ? void 0 : recordingContext.dumpRecording();
        return recordingId2;
      } else {
        return void 0;
      }
    } catch (e) {
      return void 0;
    }
  });
  const record = () => __async(void 0, null, function* () {
    try {
      const { recordingId: recordingId2, token } = (yield genAuthToken(uid, region != null ? region : "")).data;
      const recordingContext = yield recorder.startRecording({
        id: recordingId2.toString(),
        token,
        mode: RecordingMode.Streaming
      });
      window[WINDOW_KEY.STANDARD_RECORDER] = recordingContext;
      setIsRecording(true);
      setRecordingId(recordingId2.toString());
      return recordingId2.toString();
    } catch (e) {
      setIsRecording(false);
      return void 0;
    }
  });
  const stopRecording = () => __async(void 0, null, function* () {
    try {
      setIsRecording(false);
      const recordingContext = window[WINDOW_KEY.STANDARD_RECORDER];
      yield recordingContext == null ? void 0 : recordingContext.stopRecording();
      window[WINDOW_KEY.STANDARD_RECORDER] = void 0;
    } catch (e) {
      window[WINDOW_KEY.STANDARD_RECORDER] = void 0;
    }
  });
  useEffect(() => {
    return () => {
      stopRecording();
    };
  }, []);
  const recordingMetaInfo = useMemo(() => {
    return {
      id: recordingId,
      isRecording
    };
  }, [recordingId, isRecording]);
  return {
    stopRecording,
    record,
    recordingMetaInfo,
    isRecording,
    startBlackboxRecording,
    dumpBlackboxRecording
  };
};
const SessionReplayCoreModel = createModel(useSessionReplayCore);
var useSessionReplayCore_default = SessionReplayCoreModel.useContext;
export {
  SessionReplayCoreModel,
  useSessionReplayCore_default as default,
  useSessionReplayCore
};
